import { render } from "./leaderWatchlist.vue?vue&type=template&id=68e294c4"
import script from "./leaderWatchlist.vue?vue&type=script&lang=js"
export * from "./leaderWatchlist.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__